var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","fill":"#0F344E"}}),_c('path',{attrs:{"d":"M18 11H6v2h12v-2z","fill":"#fff"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }